import React from 'react';
import { Navigate } from 'react-router-dom';
import { Result } from 'antd';
import { useAuth } from '../contexts/AuthContext';

const AdminRoute = ({ children }) => {
  const { user, canViewAdmin } = useAuth();

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (!canViewAdmin()) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="抱歉，您沒有權限訪問此頁面"
      />
    );
  }

  return children;
};

export default AdminRoute;